import PropTypes from 'prop-types';
import React from 'react';

import { observer } from 'mobx-react';
import CustomFormField from '../../../models/CustomFormField';
import FormField from '../../../models/FormField';
import { modelOf } from '../../../prop-types';

export const createOption = ({ disabled, value, label, content }) => {
  return {
    disabled,
    value,
    label,
    content,
  };
};

const Field = ({
  component: Component,
  field,
  onBlur,
  onChange,
  value,
  innerRef,
  validate = true,
  ...rest
}) => {
  const handleChange = (event) => {
    field.setValue(event.target.value);
    onChange && onChange(event, field);
  };

  const handleBlur = (event) => {
    if (field.value && validate) {
      field.setShouldValidate(true);
    }

    onBlur && onBlur(event, field);
  };

  let fieldValue;
  if (
    ['radio', 'checkbox'].indexOf(rest.type) === -1 &&
    field.value !== undefined &&
    field.value !== null
  ) {
    fieldValue = field.value;
  } else if (value) {
    fieldValue = value;
  } else {
    fieldValue = '';
  }

  return (
    <Component
      valid={field.valid}
      invalid={field.errors.length > 0}
      value={fieldValue}
      onChange={handleChange}
      onBlur={handleBlur}
      {...rest}
    />
  );
};

Field.propTypes = {
  field: PropTypes.oneOfType([modelOf(FormField), modelOf(CustomFormField)])
    .isRequired,
  component: PropTypes.func.isRequired,
  validate: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
};

export default observer(Field);
